import {type Event} from '#/cms/schemas/event.schema';

export function getEventAddressString(event: Event): string | null {
  const {addressLine1, addressLine2, addressCity, addressCounty, addressPostcode} = event;
  if (!addressLine1 && !addressLine2 && !addressCity && !addressCounty && !addressPostcode) {
    return null;
  }
  return [addressLine1, addressLine2, addressCity, addressCounty, addressPostcode].filter(Boolean).join(', ');
}
